import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";
import CheckoutItemsList from "./CheckoutItemsList";
import CheckoutPriceDetails from "./CheckoutPriceDetails";
import { CheckoutWrapper } from "./style";
import styled from "styled-components";
import CheckoutPriceDetailsNew from "./CheckoutPriceDetails/CheckoutPriceNew";
import CheckoutItemsListNew from "./CheckoutItemsList/indexnew";

const CheckoutNew = () => {
  const AllCartItems = useSelector(
    (state) => state.AllCartItems?.AllCartData || []
  );

  
  const userProfile = useSelector((state) => state.userDetails || {});
  const { isGuest = true } = userProfile;
  const { cartPriceDetail = {}, shipments = [] } = AllCartItems;

  

  const CheckoutWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 100vh;
    background-color: #f5f5f5;
    margin-top: 4rem;
    padding: 2rem 1rem 1rem 1rem;
    font-family: "Ancizar Sans", sans-serif;

    @media (max-width: 900px) {
      flex-direction: column;
       padding: 5rem 1rem 1rem 1rem;
    }
  `;
  const CheckoutLeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    width: 101%;

    @media (max-width: 900px) {
      flex: unset;
      width: 100%;
    }
  `;

  const CheckoutRightContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;


  `;

  return (
    <CheckoutWrapper>
      <CheckoutLeftContainer>
        <CheckoutItemsListNew />
      </CheckoutLeftContainer>
      <CheckoutRightContainer>
        <CheckoutPriceDetailsNew
          cartPriceDetail={cartPriceDetail}
          shipmentsLen={shipments.length}
        />
      </CheckoutRightContainer>
    </CheckoutWrapper>
  );
};

export default CheckoutNew;
